var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPhotoNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M.5.5h199v249.001H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M199 1v248.001H1V1h198m1-1H0v250.001h200V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.718 159.669c-10.055 7.283-22.372 11.633-35.718 11.633-13.342 0-25.661-4.35-35.72-11.633C30.633 171.17 6.344 203.03 6.344 240.528a4.073 4.073 0 0 0 4.071 4.07h179.172a4.072 4.072 0 0 0 4.069-4.07c0-37.498-24.287-69.358-57.938-80.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 57.286c-29.188 0-52.935 23.748-52.935 52.935 0 29.19 23.746 52.935 52.935 52.935 29.19 0 52.935-23.744 52.935-52.935 0-29.187-23.745-52.935-52.935-52.935z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotoNeutral);
export default __webpack_public_path__ + "static/media/no_photo_neutral.8685b6069eba72b8a5bd5a1c8ac0a544.svg";
export { ForwardRef as ReactComponent };